import React, { useState, useEffect } from 'react';

function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);

  const services = [
    { 
      icon: 'fas fa-chart-line', 
      title: 'Double Side Rotary Tableting Machine',
      link: '/double-side-rotary-tableting-machine'
    },
    { 
      icon: 'fas fa-pills', 
      title: 'High Speed Double Side Rotary Tablet Press',
      link: '/high-speed-double-side-rotary-tablet-press'
    },
    { 
      icon: 'fas fa-capsules', 
      title: 'Single Side Rotary Tablet Press (GMP)',
      link: '/single-rotary-tablet-press'
    },
    { 
      icon: 'fas fa-vials', 
      title: 'Mini Rotary Tablet Press',
      link: '/mini-rotary-tablet-press'
    },
    { 
      icon: 'fas fa-mortar-pestle', 
      title: 'Fluid Bed Dryer (FBD)',
      link: '/fluid-bed-dryer'
    }
  ];

  // Sticky header on scroll
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Prevent body scroll when mobile menu is open
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMobileMenuOpen]);

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
    setIsServicesOpen(false);
  };

  const toggleServices = (e) => {
    e.preventDefault();
    setIsServicesOpen(!isServicesOpen);
  };

  return (
    <>
      <style>{`
        .hamburger-area {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100vh;
          z-index: 9999;
          visibility: hidden;
          opacity: 0;
          transition: visibility 0s 0.3s, opacity 0.3s ease;
        }

        .hamburger-area.active {
          visibility: visible;
          opacity: 1;
          transition: visibility 0s, opacity 0.3s ease;
        }

        .hamburger_bg {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.7);
          z-index: 1;
        }

        .hamburger_wrapper {
          position: absolute;
          top: 0;
          right: 0;
          width: 85%;
          max-width: 400px;
          height: 100%;
          background: #fff;
          z-index: 2;
          transform: translateX(100%);
          transition: transform 0.3s ease;
          overflow-y: auto;
          display: flex;
          flex-direction: column;
        }

        .hamburger-area.active .hamburger_wrapper {
          transform: translateX(0);
        }

        .hamburger_inner {
          flex: 1;
          padding: 1.5rem;
        }

        .hamburger_top {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 1.5rem;
          padding-bottom: 1rem;
          border-bottom: 1px solid #eee;
        }

        .mobile_logo img {
          height: 40px;
        }

        .hamburger_close_btn {
          background: none;
          border: none;
          font-size: 1.5rem;
          cursor: pointer;
          padding: 0.5rem;
          color: #333;
        }

        .hamburger-title {
          font-size: 1.1rem;
          margin-bottom: 1rem;
          color: #333;
          font-weight: 600;
        }

        .mobile-nav ul {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .mobile-nav > ul > li {
          border-bottom: 1px solid #eee;
        }

        .mobile-nav > ul > li > a {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 1rem 0;
          color: #333;
          text-decoration: none;
          font-size: 1rem;
          font-weight: 500;
        }

        .has-dropdown .submenu {
          max-height: 0;
          overflow: hidden;
          transition: max-height 0.3s ease;
        }

        .has-dropdown.open .submenu {
          max-height: 500px;
          margin-top: 10px;
        }

        .submenu li {
          margin-bottom: 8px;
        }

        .submenu li a {
          display: block;
          padding: 0.5rem 0;
          color: #666;
          text-decoration: none;
          font-size: 0.95rem;
        }

        .hamburger-infos {
          margin-top: 1.5rem;
          padding-top: 1.5rem;
          border-top: 1px solid #eee;
        }

        .contact-item {
          margin-bottom: 1rem;
        }

        .subtitle {
          display: block;
          font-size: 0.85rem;
          color: #999;
          margin-bottom: 0.25rem;
        }

        .contact-link {
          display: block;
          color: #333;
          text-decoration: none;
          font-size: 0.95rem;
        }

        .hamburger-socials {
          padding: 1.5rem;
          background: #f8f9fa;
          border-top: 1px solid #eee;
        }

        .social-links ul {
          display: flex;
          gap: 1rem;
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .social-links a {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 40px;
          height: 40px;
          background: #fff;
          border-radius: 50%;
          color: #333;
          text-decoration: none;
          transition: all 0.3s ease;
        }

        .social-links a:hover {
          background: #333;
          color: #fff;
        }

        .menu_bar {
          display: flex;
          flex-direction: column;
          gap: 5px;
          cursor: pointer;
          padding: 10px;
        }

        .menu_bar span {
          width: 25px;
          height: 3px;
          background: #333;
          border-radius: 3px;
          transition: all 0.3s ease;
        }

        @media (min-width: 992px) {
          .hamburger-area {
            display: none !important;
          }
        }
      `}</style>
      {/* Hamburger Menu */}
      <div className={`hamburger-area d-lg-none ${isMobileMenuOpen ? 'active' : ''}`}>
        <div className="hamburger_bg" onClick={closeMobileMenu}></div>
        <div className="hamburger_wrapper">
          <div className="hamburger_inner">
            <div className="hamburger_top d-flex align-items-center justify-content-between">
              <div className="hamburger_logo">
                <a href="/" className="mobile_logo" onClick={closeMobileMenu}>
                  <img src="assets/images/logos/logo-header.jpg" alt="Logo" />
                </a>
              </div>
              <div className="hamburger_close">
                <button className="hamburger_close_btn" onClick={closeMobileMenu} type="button">
                  <i className="fa-solid fa-xmark"></i>
                </button>
              </div>
            </div>
            <div className="hamburger_menu">
              <nav className="mobile-nav">
                <ul>
                  <li>
                    <a href="/" onClick={closeMobileMenu}>Home</a>
                  </li>
                  <li>
                    <a href="/about" onClick={closeMobileMenu}>About Us</a>
                  </li>
                  <li className={`has-dropdown ${isServicesOpen ? 'open' : ''}`}>
                    <a href="#" onClick={toggleServices}>
                      Services
                      <i className={`fa-solid fa-angle-${isServicesOpen ? 'up' : 'down'}`} style={{ marginLeft: '8px', fontSize: '14px' }}></i>
                    </a>
                    <ul className="submenu" style={{ 
                      display: isServicesOpen ? 'block' : 'none',
                      paddingLeft: '20px',
                      marginTop: '10px'
                    }}>
                      {services.map((service, idx) => (
                        <li key={idx} style={{ marginBottom: '8px' }}>
                          <a href={service.link} onClick={closeMobileMenu}>
                            {service.title}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </li>
                  <li>
                    <a href="/services" onClick={closeMobileMenu}>Our Products</a>
                  </li>
                  <li>
                    <a href="/contact" onClick={closeMobileMenu}>Contact</a>
                  </li>
                </ul>
              </nav>
            </div>
            <div className="hamburger-infos">
              <h5 className="hamburger-title">Contact Info</h5>
              <div className="contact-info">
                <div className="contact-item">
                  <span className="subtitle">Phone</span>
                  <a className="contact-link" href="tel:9537503030">+91 95375 03030</a>
                </div>
                <div className="contact-item">
                  <span className="subtitle">Email</span>
                  <a className="contact-link" href="mailto:sdpharma795@gmail.com">sdpharma795@gmail.com</a>
                </div>
                <div className="contact-item">
                  <span className="subtitle">Location</span>
                  <span className="contact-link">Block A1/501, Sarthi Parisar, Nr.Pushp Vihar, Ahmedabad-380058, Gujarat, India</span>
                </div>
              </div>
            </div>
          </div>
          <div className="hamburger-socials">
            <h5 className="hamburger-title">Follow Us</h5>
            <div className="social-links style-3">
              <ul>
                <li><a href="https://www.facebook.com/" target="_blank" rel="noreferrer"><i className="fa-brands fa-facebook-f"></i></a></li>
                <li><a href="https://www.instagram.com/" target="_blank" rel="noreferrer"><i className="fa-brands fa-instagram"></i></a></li>
                <li><a href="https://x.com/" target="_blank" rel="noreferrer"><i className="fa-brands fa-x-twitter"></i></a></li>
                <li><a href="https://www.linkedin.com/" target="_blank" rel="noreferrer"><i className="fa-brands fa-linkedin-in"></i></a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Main Header */}
      <header className="header-area header-1">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="header-wrapper">
                <div className="site_logo">
                  <a className="logo" href="/">
                    <img src="assets/images/logos/logo-header.jpg" alt="" />
                  </a>
                </div>

                <div className="menu-area d-none d-lg-inline-flex align-items-center">
                  <nav id="mobile-menu" className="mainmenu">
                    <ul>
                      <li>
                        <a href="/">Home</a>
                      </li>
                      
                      <li>
                        <a href="/about">About Us</a>
                      </li>
                      
                      <li className="has-dropdown">
                        <a href="#">Services</a>
                        <ul className="sub-menu mega-menu-service">
                          {services.map((service, idx) => (
                            <li key={idx}>
                              <a className="mega-menu-service-single" href={service.link}>
                                <span className="mega-menu-service-title">{service.title}</span>
                                <span className="mega-menu-service-nav">
                                  <i className="fas fa-arrow-right"></i>
                                </span>
                              </a>
                            </li>
                          ))}
                        </ul>
                      </li>
                      
                      <li>
                        <a href="/services">Our Products</a>
                      </li>
                      
                      <li><a href="/contact">Contact</a></li>
                    </ul>
                  </nav>
                </div>

                <div className="header-right-item d-none d-lg-inline-flex">
                  <div className="header-button">
                    <a className="tj-primary-btn" href="/contact">
                      <span className="btn-text"><span>Let's Talk</span></span>
                      <span className="btn-icon"><i className="fas fa-arrow-right"></i></span>
                    </a>
                  </div>
                </div>

                <div 
                  className="menu_bar mobile_menu_bar d-lg-none" 
                  onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                  style={{ cursor: 'pointer' }}
                >
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Sticky Header */}
      <header className={`header-area header-3 header-duplicate ${isSticky ? 'sticky' : ''}`}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="header-wrapper">
                <div className="site_logo">
                  <a className="logo" href="/">
                    <img src="assets/images/logos/logo-header.jpg" alt="" />
                  </a>
                </div>

                <div className="menu-area d-none d-lg-inline-flex align-items-center">
                  <nav className="mainmenu">
                    <ul>
                      <li>
                        <a href="/">Home</a>
                      </li>
                      
                      <li>
                        <a href="/about">About Us</a>
                      </li>
                      
                      <li className="has-dropdown">
                        <a href="#">Services</a>
                        <ul className="sub-menu mega-menu-service">
                          {services.map((service, idx) => (
                            <li key={idx}>
                              <a className="mega-menu-service-single" href={service.link}>

                                <span className="mega-menu-service-title">{service.title}</span>
                                <span className="mega-menu-service-nav">
                                  <i className="fas fa-arrow-right"></i>
                                </span>
                              </a>
                            </li>
                          ))}
                        </ul>
                      </li>
                      
                      <li>
                        <a href="/services">Our Products</a>
                      </li>
                      
                      <li><a href="/contact">Contact</a></li>
                    </ul>
                  </nav>
                </div>

                <div className="header-right-item d-none d-lg-inline-flex">
                  <div className="header-button">
                    <a className="tj-primary-btn" href="/contact">
                      <span className="btn-text"><span>Let's Talk</span></span>
                      <span className="btn-icon"><i className="fas fa-arrow-right"></i></span>
                    </a>
                  </div>
                </div>

                <div 
                  className="menu_bar mobile_menu_bar d-lg-none" 
                  onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                  style={{ cursor: 'pointer' }}
                >
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}

export default Header;